import script from "./main-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./main-content.vue?vue&type=script&setup=true&lang=ts"

import "./main-content.vue?vue&type=style&index=0&id=bbf2dcaa&lang=scss"

const __exports__ = script;

export default __exports__